module.exports = __webpack_public_path__ + "static/media/portfolio2014Contact.fbc365e9.jpg";